<template>
  <Tree
    :data="item.treeData"
    :show-checkbox="item.showCheckbox"
    @on-select-change="(selected, current) => { item.onSelectChange && item.onSelectChange(selected, current, item) }"
    @on-check-change="(selected, current) => { item.onCheckChange && item.onCheckChange(selected, current, item) }"
  />
</template>
<script>
import props from './props'
export default {
  name: 'form-item-tree',
  mixins: [props],
  data () {
    return {}
  }
}
</script>